import './Navigation.css';

function Navigation() {
  return (
    <nav className="navigation">
      <div className="nav-brand">
        <span>PixelsParadox</span>
      </div>
      <div className="nav-links">
        <a href="mailto:pixelsparadox0@gmail.com">Contact</a>
      </div>
    </nav>
  );
}

export default Navigation;

